import { render, staticRenderFns } from "./deviationTests.vue?vue&type=template&id=5541a6ec"
import script from "./deviationTests.js?vue&type=script&lang=js&external"
export * from "./deviationTests.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports